import { useSyncExternalStore } from "react";
import { api, AUTH_EVENT } from "../api";
import type { Me } from "../types";

/** Кто сейчас вошёл. undefined — ещё не знаем (идёт первый запрос /api/auth/me). */
let current: Me | undefined;
let demoMarkets: string[] = [];
const listeners = new Set<() => void>();

const ANON: Me = { authenticated: false, username: null, role: null, mustChangePassword: false };

function set(me: Me) {
  current = me;
  listeners.forEach((l) => l());
}

export const auth = {
  async refresh() {
    try {
      const [me, demo] = await Promise.all([api.me(), api.demoInfo().catch(() => ({ markets: [] }))]);
      demoMarkets = demo.markets;
      set(me);
    } catch {
      set(ANON);
    }
  },
  async login(username: string, password: string) {
    set(await api.login(username, password));
  },
  async logout() {
    try {
      await api.logout();
    } finally {
      set(ANON);
    }
  },
  async changePassword(currentPassword: string, newPassword: string) {
    set(await api.changePassword(currentPassword, newPassword));
  },
  isDemoMarket(code: string) {
    return demoMarkets.includes(code);
  },
  demoMarkets() {
    return demoMarkets;
  },
};

// Сервер сказал «не вошли» — сессия истекла или пользователя удалили.
window.addEventListener(AUTH_EVENT, (e) => {
  const d = (e as CustomEvent<{ status: number; code?: string }>).detail;
  if (d.status === 401) set(ANON);
  else if (d.code === "PASSWORD_CHANGE_REQUIRED" && current) set({ ...current, mustChangePassword: true });
});

void auth.refresh();

export function useAuth(): Me | undefined {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
